"use client";

import { useState } from "react";
import { toast } from "react-hot-toast";
import Modal from "../../../components/shared-modules/Modal";
import styles from "../../../styles/statusModal.module.css";
import { deleteStatus } from "../../../services/admin/statuses";
import { handleApiError } from "../../../utils/handleApiError";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import Button from "../../../components/button-v1";
import AlertDialog from "../../../components/alert-dialogue";
import { useQueryClient } from "@tanstack/react-query";
const DeleteStatus = ({
  isOpen,
  onClose,
  status_info,
  comp_renderer,
  current_render,
}) => {
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);

    try {
      await deleteStatus(status_info.id);
      // comp_renderer(!current_render);
      queryClient.invalidateQueries(["admin-statuses"]);

      toast.success(`Status "${status_info?.name}" deleted successfully`);
      onClose();
      setLoading(false);
    } catch (error) {
      handleApiError(error);
      setLoading(false);
    }
  };

  return (
    <AlertDialog
      open={isOpen}
      setOpen={onClose}
      title="Delete Status"
      description={`Are you sure you want to delete it`}
    >
      <Button variant="ghost" size="default" onClick={onClose}>
        Cancel
      </Button>
      <Button loading={loading} variant="danger" onClick={handleDelete}>
        Delete
      </Button>
    </AlertDialog>
  );
};

export default DeleteStatus;
